module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/rule_frame-2636a0cfd900b16d977e10a02ad8d908.svg";